// Apolo IDE — CompareView (Sprint v4 Epic S1 WS S1.3).
//
// Renders the side-by-side comparison grid. Layout adapts to the count:
//   - 2 models  → 2 columns (50/50)
//   - 3 models  → 3 columns (33/33/33)
//   - 4–6 models → 3 columns with horizontal scroll (rows wrap)
//
// Skeleton state shown while `busy=true && results.length===0`. Empty
// state shown only when explicitly toggled but no run has happened yet.

import { Loader2, Columns3 } from 'lucide-react';
import CompareColumn from './CompareColumn.jsx';

function skeletonClass(count) {
  if (count <= 2) return 'grid grid-cols-1 gap-3 md:grid-cols-2';
  if (count === 3) return 'grid grid-cols-1 gap-3 md:grid-cols-3';
  return 'grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3';
}

export default function CompareView({
  results,
  busy,
  modelsCount,
  totalCostUsd,
  winnerSubagentId,
  onPickWinner,
  error,
}) {
  if (error) {
    return (
      <div
        role="alert"
        className="rounded-lg border border-apolo-error/40 bg-apolo-error/10 p-3 text-xs text-apolo-error"
      >
        Compare falhou: {String(error)}
      </div>
    );
  }

  if (!results || results.length === 0) {
    if (busy) {
      return (
        <div className={skeletonClass(modelsCount || 2)} data-testid="compare-skeleton">
          {Array.from({ length: modelsCount || 2 }).map((_, i) => (
            <div
              key={i}
              className="flex h-48 items-center justify-center rounded-lg border border-dashed border-apolo-borderSubtle bg-apolo-surface1 text-apolo-textTertiary"
            >
              <Loader2 size={16} className="animate-spin" aria-hidden="true" />
              <span className="ml-2 text-xs">Aguardando resposta…</span>
            </div>
          ))}
        </div>
      );
    }
    return (
      <div
        className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-apolo-borderSubtle bg-apolo-surface1 p-6 text-center text-apolo-textTertiary"
        data-testid="compare-empty"
      >
        <Columns3 size={18} aria-hidden="true" />
        <p className="text-xs">Compare Mode ativo. Envie um prompt para comparar respostas.</p>
      </div>
    );
  }

  const count = results.length;
  return (
    <section aria-label="Resultado do Compare Mode" data-testid="compare-view">
      <div className={skeletonClass(count)}>
        {results.map((r) => (
          <CompareColumn
            key={r.subagentId || r.model}
            result={r}
            isWinner={winnerSubagentId === (r.subagentId || r.model)}
            onPickWinner={onPickWinner}
          />
        ))}
      </div>

      {typeof totalCostUsd === 'number' && totalCostUsd > 0 ? (
        <p
          className="mt-2 text-right text-[11px] text-apolo-textTertiary"
          aria-label={`Custo total do compare: $${totalCostUsd.toFixed(4)}`}
        >
          Total: ${totalCostUsd.toFixed(4)}
        </p>
      ) : null}
    </section>
  );
}
